import { useState, useEffect, } from "react";
import Box from '@mui/material/Box';
import { getEndpoint, getMUICache, getUrl, getImageUrl, handleSearchClick, getLoggedUserName, getLoggedUserEmail, logoutUser, getLoggedInFlag, safeCharAt, fetchAnchorValue } from "../../../common/utils";
import Grid from '@mui/material/Grid';
import { CacheProvider } from '@emotion/react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import List from '@mui/joy/List';
import ListItem from '@mui/joy/ListItem';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { Link } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import DrawerComponentThree from "../SidebarThree/DrawerComponentThree";
import { PAGEBUILDER_URLS } from "../../Common/Constant.js";
import bcrypt from 'bcryptjs-react';
import './HeaderThree.css';
import './HeaderOther.css';
import ListItemButton from '@mui/joy/ListItemButton';

HeaderThree.version = 1000;
HeaderThree.lang = 'en';
HeaderThree.langs = [
  'en'
];
HeaderThree.setLang = (lang: any) => {
  HeaderThree.lang = lang;
}

Object.defineProperty(HeaderThree, 'name', {
  writable: true,
  value: 'HeaderThree'
});

// Define a type for the fetch options
interface FetchOptions {
  method: string;
  headers: {
    'Content-Type': string;
    'p-nonce': string;
  };
  credentials?: RequestCredentials;
}
const style = {
  position: 'absolute' as 'absolute',
  width: 800,
  bgcolor: 'background.paper',
  boxShadow: 24,
};

export function HeaderThree(props: any) {

  const { anchorLinksValue, L1BgColor, L1TextColor, L2BgColor, L2TextColor, domainUrl} = props;

  const [menuItems, setMenuItems] = useState<any>([]);
  const [headerData, setHeaderData] = useState<any>({});
  const [showMainMenu, setMainMenu] = useState(false);
  const [toogleMenuData, setToggleMenuData] = useState<any>([]);
  const [Closebtn, setClosebtn] = useState<any>(false);
  const [searchValue, setSearchValue] = useState<any>("");
  const [SearchBar, setSearchBar] = useState<any>(false);
  const [isActive, setIsActive] = useState<any>(false);
  const [loggedUserName, setLoggedUserName] = useState<any>("");
  const [loggedUserEmail, setLoggedUserEmail] = useState<any>("");
  const [loginLink, setLoginLink] = useState<any>();
  const [loginEnabled, setLoginEnabled] = useState(false);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  // const [showMore, setShowMore] = useState(false);
  //const MAX_MENU_ITEMS = 6; // Maximum number of menu items to display

  const endpointHostId = getEndpoint(props, "HEADER_MENU_API");
  const hostId = endpointHostId.queryParams.hostId;
  const toggleClass = () => {
    setIsActive(!isActive);
  };

  if (!loginEnabled && props && props.transportData && props.transportData.isLoginEnabled) {
    setLoginEnabled(props.transportData.isLoginEnabled);
  }

  const { onClick, showSearch, isSticky, noOfHeaderItems } = props;
  const endpoint = getEndpoint(props, "MAIN");
  //const headerMenuEndpoint = getEndpoint(props, "HEADER_MENU_API");
  const togglerEndpoint = getEndpoint(props, "TOGGLER_MENU_API");
  const breadCrumsEndpoint = getEndpoint(props, "BREAD_CRUMBS_API");
  useEffect(() => {
    setLoggedUserName(getLoggedUserName());
    setLoggedUserEmail(getLoggedUserEmail());
    setLoginLink("/login?url=" + encodeURIComponent(window.location.href));
    if (!endpoint.isSSR || !endpoint.SSRDataObj || !togglerEndpoint.isSSR || !togglerEndpoint.SSRDataObj) {
      fetchComponentData();
    }
    if (!loginEnabled && props && props.transportData && props.transportData.isLoginEnabled) {
      setLoginEnabled(props.transportData.isLoginEnabled);
    }
    setLoginEnabled(getLoggedInFlag());
  }, []);

  if (endpoint.isSSR && endpoint.SSRDataObj && (!headerData || !Object.keys(headerData).length)) {
    setHeaderData(endpoint.SSRDataObj);
    if (isSticky) {
      setTimeout(() => {
        if (typeof document !== 'undefined' && undefined !== document && document && document.getElementsByTagName("header") && document.getElementsByTagName("header")[0])
          document.getElementsByTagName("header")[0].classList.add("sticky");
      })
    }
  }

  if (togglerEndpoint.isSSR && togglerEndpoint.SSRDataObj && togglerEndpoint.SSRDataObj.length && (!menuItems || !menuItems.length)) {
    setMenuItems(togglerEndpoint.SSRDataObj);
  }

  if (togglerEndpoint.isSSR && togglerEndpoint.SSRDataObj && togglerEndpoint.SSRDataObj.length && (!toogleMenuData || !toogleMenuData.length)) {
    setToggleMenuData(togglerEndpoint.SSRDataObj);
  }

  const toggleMainMenu = () => {
    if (toogleMenuData.length == 0) {
      getToggleMenuData();
    } else {
      setMainMenu(!showMainMenu);
    }
  }

  const getUrllocal = (domainUrl: string, path: string) => {
    if (path && path.startsWith("http")) { return path; }
    if (!domainUrl) { return }
    let updatedDomain = domainUrl;
    if (domainUrl.length > 0 && domainUrl[domainUrl.length - 1] == "/") {
      updatedDomain = domainUrl.substring(0, domainUrl.length - 1)
    }

    return updatedDomain + path;
  }

  const getToggleMenuData = () => {
    let toggleMenuAPIurl = getUrl(props, 0, false, "TOGGLER_MENU_API", true)
    let headerString = '?' + toggleMenuAPIurl.split("?")[1];
    headerString = bcrypt.hashSync(headerString, 6);
    const headers = { 'p-nonce': headerString };

    fetch(toggleMenuAPIurl, { headers: headers }).then((response) => response.json())
      .then((val) => setToggleMenuData(val))
      .then(() => setMainMenu(true))
  }

  const fetchComponentData = () => {
    const { ENDPOINTS } = props;
    let headerAPI = getUrl(props, 0, false, "MAIN", true, ENDPOINTS[0].queryParams.websiteId, ENDPOINTS[0].queryParams.clientId)
    let menuAPIurl = getUrl(props, 0, false, "TOGGLER_MENU_API", true)
    let headerString = `?` + headerAPI.split("?")[1];
    headerString = bcrypt.hashSync(headerString, 6);
    const customHeaders = {
      'Content-Type': 'application/json',
      'p-nonce': headerString
    };
    var fetchOptions: FetchOptions = {
      method: 'GET',
      headers: customHeaders
    };

    let headerString_menuAPIurl = '?' + menuAPIurl.split("?")[1];
    headerString_menuAPIurl = bcrypt.hashSync(headerString_menuAPIurl, 6);
    const headers_menuAPIurl = { 'p-nonce': headerString_menuAPIurl };

    if (headerAPI.includes('getsiteResources') && !headerAPI.includes("rendering/getsiteResources") &&
      (typeof document !== 'undefined' && undefined !== document && document
        && !PAGEBUILDER_URLS.some(domain => window.location.origin.includes(domain)))) {
      headerAPI = headerAPI.replace("getsiteResources", "rendering/getsiteResources");
    } else { fetchOptions.credentials = "include"; }
    Promise.all([
      fetch(headerAPI, fetchOptions).then((response) => response.json()),
      fetch(menuAPIurl, { headers: headers_menuAPIurl }).then((response) => response.json()),
    ])
      .then(([result1, result2]) => {
        // Handle the results individually
        setHeaderData(result1);
        setMenuItems(result2);
      })
      .catch((error) => {
        // Handle errors here
        console.error('Error fetching data:', error);
      });
  }

  // const extractValue = (str: string | null) => {
  //   // Check if str is null or not a string
  //   if (typeof str !== 'string') {
  //     return null;
  //   }

  //   // Regular expression to capture the string after '/topics/' or '/tags/' before any query parameters
  //   const regex = /\/(topics|tags)\/([^?]*)/;
  //   const match = str.match(regex);

  //   // If there's a match, return the captured value (after '/' and before '?')
  //   return match ? match[2] : null;
  // };


  const toggleMenu = () => {
    document.body.classList.add("modal-open");
  };


  const [scroll, setScroll] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 20);
    });
  }, []);

  const showSearchBar = () => {
    setSearchBar(true)
    setClosebtn(true)
  }
  const closehandler = () => {
    setSearchBar(true)
    setClosebtn(true)
  }
  const handleKeyPress = (event: any) => {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent form submission or new window/popup
      handleSearchClick(searchValue, hostId); // Call your search handling function
    }
  }

  const rendertopBar = () => {
    return <AppBar position="relative" color='default' className={scroll ? "bg-black" : "bg-white"} >
      <Toolbar className='header-top InnerHeaderTop'>
        <div className="header-left">
          {/* <div id="HeaderlogoIn" className="">
            <Link href="/" aria-label="logo" target="_self" className="main-logo">
              {headerData?.mainLogo && <img src={getImageUrl(headerData?.mainLogo, "422424", 96, undefined, "", false, props.CONSTANTS)} alt="logo" width="96" height="36" />}
            </Link>
          </div>
          <div className="sidebar-menu-icon mobileThemeThreeIcon" onClick={() => { toggleMainMenu(); toggleClass(); toggleMenu(); }}>
            <IconButton size="large" edge="start" color="inherit" aria-label="open drawer" sx={{ mr: 2 }} className={isActive ? 'hamburgerActiveClass' : 'hamburgerInactiveClass'}>
              <MenuIcon />
            </IconButton>
          </div> */}
          {/* <div className='themeThreeSearchIcon mobileThemeThreeSearch'>
            {!Closebtn && <SearchIcon onClick={() => showSearchBar()} />}
            {Closebtn && <CloseIcon onClick={() => closehandler()} />}
            {(showSearch && SearchBar) &&
              <div className='themeSearchMainWrap'>
                <div className="search-main">
                  <div className="search" >
                  </div>
                </div>
              </div>
            }
          </div> */}
        </div>
      </Toolbar>
    </AppBar>
  }
  let defaultDomainUrl: any = "";
  if (typeof window !== 'undefined' && undefined !== window && window) {
    defaultDomainUrl = "https://" + window.location.hostname;
  } else {
    defaultDomainUrl = (props && props.REQUEST_HOSTNAME) && "https://" + props.REQUEST_HOSTNAME;
  }

  //Rendering Navigation Handling starts
  let requestId: any = null;
  let REQUEST_URL: any = null;
  let REQUEST_HOSTNAME: any = null;
  let SOURCE_REQUEST_URL: any = null;
  let sourceRequestId: any = null;
  let requestIdList: string[] = [];
  let REQUEST_URL_List: string[] = [];

  if (!(typeof window !== 'undefined' && PAGEBUILDER_URLS.some(url => window.location.origin.includes(url)))) {

    if (props && props.REQUEST_URL) {
      REQUEST_URL = props.REQUEST_URL;
    }
    if (props && props.REQUEST_HOSTNAME) {
      REQUEST_HOSTNAME = props.REQUEST_HOSTNAME;
    }
    if (props && props.SOURCE_REQUEST_URL) {
      SOURCE_REQUEST_URL = props.SOURCE_REQUEST_URL;
    }
    // console.log("REQUEST_URL :: " + REQUEST_URL);
    // console.log("REQUEST_HOSTNAME :: " + REQUEST_HOSTNAME);
    // console.log("SOURCE_REQUEST_URL :: " + SOURCE_REQUEST_URL);
    const idMatch = REQUEST_URL.match(/\/(\d+)\.html/);
    requestId = idMatch ? idMatch[1] : null;

    if (REQUEST_URL != null && requestId == null) {
      if (REQUEST_URL.includes('/topics/')) {
        requestId = REQUEST_URL.split("/topics/")[1].split("?")[0];
      } else if (REQUEST_URL.includes('/tags/')) {
        const parts = REQUEST_URL.split("/");
        const encodedText = parts[parts.length - 1];
        const decodedText = decodeURIComponent(encodedText);
        requestId = decodedText.split("?")[0];
      }
    }

    if (requestId && requestId !== "") { requestIdList.push(requestId.toString()); }
    if (REQUEST_URL) {
      REQUEST_URL_List.push(REQUEST_URL);
      if (REQUEST_URL.includes('?')) REQUEST_URL_List.push((REQUEST_URL.split('?')[0]));
    }
    if (SOURCE_REQUEST_URL && !(REQUEST_URL && REQUEST_URL === SOURCE_REQUEST_URL)) {
      REQUEST_URL_List.push(SOURCE_REQUEST_URL);
      if (SOURCE_REQUEST_URL.includes('?')) REQUEST_URL_List.push((SOURCE_REQUEST_URL.split('?')[0]));

      const idMatch2 = SOURCE_REQUEST_URL.match(/\/(\d+)\.html/);
      sourceRequestId = idMatch2 ? idMatch2[1] : null;

      if (sourceRequestId == null) {
        if (SOURCE_REQUEST_URL.includes('/topics/')) {
          requestId = SOURCE_REQUEST_URL.split("/topics/")[1].split("?")[0];
        } else if (SOURCE_REQUEST_URL.includes('/tags/')) {
          const parts = SOURCE_REQUEST_URL.split("/");
          const encodedText = parts[parts.length - 1];
          const decodedText = decodeURIComponent(encodedText);
          requestId = decodedText.split("?")[0];
        }
      }
      if (sourceRequestId && sourceRequestId !== "") { requestIdList.push(sourceRequestId.toString()); }
    }

    if (breadCrumsEndpoint && breadCrumsEndpoint.SSRDataObj && breadCrumsEndpoint.SSRDataObj.items &&
      Array.isArray(breadCrumsEndpoint.SSRDataObj.items) && breadCrumsEndpoint.SSRDataObj.items.length > 0) {
      breadCrumsEndpoint.SSRDataObj.items.map((item: any) => {
        if (item && item.id && item.id !== "") {
          requestIdList.push(item.id.toString());
        }
        if (item && item.wu) {
          REQUEST_URL_List.push(item.wu.toString());
        }
      });
    }
  }
  //Rendering Navigation Handling end



  let menuData = menuItems.slice(0, noOfHeaderItems);

  const renderMoreOption = () => {
      let optionData = menuItems?.slice(noOfHeaderItems , menuItems.length);
      return <li className="nav-item hideMoreMobile">
        <ListItemButton key="test" component="a" className="has-submenu" style={{ color: L1TextColor }}>More</ListItemButton> 
        <ul className="submenu" style={{ backgroundColor: L2BgColor }}>
          {optionData.map((menuItem: any, index: number) => {
            let morePath: string = menuItem.path;
            if (menuItem.type === 2) {
              morePath = '/tags/' + (menuItem.tagpath !== undefined ? menuItem.tagpath : '');
            }
            return <li key={index} className='submenu-item ' itemProp="name" content={menuItem.name}>
              <a href={morePath} target={fetchAnchorValue(anchorLinksValue, morePath)} style={{ color: L2TextColor }} itemProp="url" content={getUrllocal(domainUrl, morePath)}>{menuItem.name}</a>
              </li>
          }
          )}
        </ul>
      </li>
    }

  const getLoginString = () => {
    if (loginEnabled) {
      if (loggedUserName) {
        return (
          <div className="ThemeThreeWelcomeWrapper">
            <button className="ThemeThreeAfterLoginButton">
              <span>{safeCharAt(loggedUserName)}</span>
            </button>
            <ul className="ThemeThreeListLog">
              <li className="ThemeThreeDesktopUserName">
                {loggedUserName}{" "}
                <span className="ThemeThreeDesktopUserEmail">
                  {loggedUserEmail}
                </span>
              </li>
              {/* <li className="ThemeThreeDesktopUserEmail">{loggedUserEmail}</li> */}
              <li>
                {" "}
                <a onClick={logoutUser} href="javascript:void(0)">
                  Logout
                </a>
              </li>
            </ul>
          </div>
        );
      }
      return (
        <div className="ThemeThreeLoginWrapper">
          <a href={loginLink} className="ThemeThreeLoginAnchor">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0 4C0 1.79086 1.79086 0 4 0H28C30.2091 0 32 1.79086 32 4V28C32 30.2091 30.2091 32 28 32H4C1.79086 32 0 30.2091 0 28V4Z"
                fill="#F29D38"
              />
              <mask id="path-2-inside-1_13_3229" fill="white">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M20.33 18.45C21.6914 18.45 22.9971 18.9908 23.9598 19.9535C24.9225 20.9162 25.4633 22.2219 25.4633 23.5833V25.75L25.4571 25.8503C25.4077 26.2448 25.0712 26.55 24.6633 26.55C24.2215 26.55 23.8633 26.1918 23.8633 25.75V23.5833C23.8633 22.6462 23.4911 21.7475 22.8284 21.0849L22.6714 20.9372C22.0273 20.3672 21.195 20.05 20.33 20.05H11.6634L11.4479 20.0566C10.5894 20.109 9.77658 20.4732 9.16492 21.0849C8.50229 21.7475 8.13003 22.6462 8.13003 23.5833V25.75L8.1238 25.8503C8.07443 26.2448 7.73787 26.55 7.33003 26.55C6.8882 26.55 6.53003 26.1918 6.53003 25.75V23.5833L6.53634 23.3288C6.59928 22.06 7.13103 20.856 8.03355 19.9535C8.99623 18.9908 10.3019 18.45 11.6634 18.45H20.33Z"
                />
              </mask>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M20.33 18.45C21.6914 18.45 22.9971 18.9908 23.9598 19.9535C24.9225 20.9162 25.4633 22.2219 25.4633 23.5833V25.75L25.4571 25.8503C25.4077 26.2448 25.0712 26.55 24.6633 26.55C24.2215 26.55 23.8633 26.1918 23.8633 25.75V23.5833C23.8633 22.6462 23.4911 21.7475 22.8284 21.0849L22.6714 20.9372C22.0273 20.3672 21.195 20.05 20.33 20.05H11.6634L11.4479 20.0566C10.5894 20.109 9.77658 20.4732 9.16492 21.0849C8.50229 21.7475 8.13003 22.6462 8.13003 23.5833V25.75L8.1238 25.8503C8.07443 26.2448 7.73787 26.55 7.33003 26.55C6.8882 26.55 6.53003 26.1918 6.53003 25.75V23.5833L6.53634 23.3288C6.59928 22.06 7.13103 20.856 8.03355 19.9535C8.99623 18.9908 10.3019 18.45 11.6634 18.45H20.33Z"
                fill="black"
              />
              <path
                d="M25.4633 25.75L27.4595 25.874L27.4633 25.8121V25.75H25.4633ZM25.4571 25.8503L27.4416 26.0987L27.4494 26.0367L27.4532 25.9743L25.4571 25.8503ZM22.8284 21.0849L24.2426 19.6706L24.2211 19.6491L24.1989 19.6283L22.8284 21.0849ZM22.6714 20.9372L24.0419 19.4805L24.0197 19.4596L23.9968 19.4394L22.6714 20.9372ZM11.6634 20.05V18.05H11.6329L11.6024 18.0509L11.6634 20.05ZM11.4479 20.0566L11.3869 18.0575L11.3564 18.0584L11.326 18.0603L11.4479 20.0566ZM8.13003 25.75L10.1262 25.874L10.13 25.8121V25.75H8.13003ZM8.1238 25.8503L10.1083 26.0987L10.1161 26.0367L10.1199 25.9743L8.1238 25.8503ZM6.53003 23.5833L4.53064 23.5338L4.53003 23.5585V23.5833H6.53003ZM6.53634 23.3288L4.53879 23.2297L4.53757 23.2544L4.53695 23.2792L6.53634 23.3288ZM8.03355 19.9535L9.44776 21.3677L9.44777 21.3677L8.03355 19.9535ZM20.33 20.45C21.161 20.45 21.958 20.7801 22.5456 21.3677L25.374 18.5393C24.0363 17.2015 22.2219 16.45 20.33 16.45V20.45ZM22.5456 21.3677C23.1332 21.9553 23.4633 22.7523 23.4633 23.5833H27.4633C27.4633 21.6915 26.7118 19.8771 25.374 18.5393L22.5456 21.3677ZM23.4633 23.5833V25.75H27.4633V23.5833H23.4633ZM23.4672 25.626L23.4609 25.7264L27.4532 25.9743L27.4595 25.874L23.4672 25.626ZM23.4726 25.602C23.5469 25.0083 24.0501 24.55 24.6633 24.55V28.55C26.0924 28.55 27.2686 27.4813 27.4416 26.0987L23.4726 25.602ZM24.6633 24.55C25.3261 24.55 25.8633 25.0872 25.8633 25.75H21.8633C21.8633 27.2964 23.117 28.55 24.6633 28.55V24.55ZM25.8633 25.75V23.5833H21.8633V25.75H25.8633ZM25.8633 23.5833C25.8633 22.1159 25.2805 20.7084 24.2426 19.6706L21.4143 22.4992C21.7018 22.7866 21.8633 23.1766 21.8633 23.5833H25.8633ZM24.1989 19.6283L24.0419 19.4805L21.3009 22.3938L21.4579 22.5415L24.1989 19.6283ZM23.9968 19.4394C22.9881 18.5467 21.6847 18.05 20.33 18.05V22.05C20.7054 22.05 21.0666 22.1876 21.346 22.4349L23.9968 19.4394ZM20.33 18.05H11.6634V22.05H20.33V18.05ZM11.6024 18.0509L11.3869 18.0575L11.5088 22.0556L11.7243 22.0491L11.6024 18.0509ZM11.326 18.0603C9.9815 18.1424 8.70861 18.7128 7.75071 19.6707L10.5791 22.4991C10.8445 22.2337 11.1973 22.0756 11.5698 22.0529L11.326 18.0603ZM7.75071 19.6707C6.713 20.7084 6.13003 22.1158 6.13003 23.5833H10.13C10.13 23.1767 10.2916 22.7867 10.5791 22.4991L7.75071 19.6707ZM6.13003 23.5833V25.75H10.13V23.5833H6.13003ZM6.13388 25.626L6.12764 25.7264L10.1199 25.9743L10.1262 25.874L6.13388 25.626ZM6.13928 25.602C6.21358 25.0083 6.71676 24.55 7.33003 24.55V28.55C8.75899 28.55 9.93528 27.4814 10.1083 26.0987L6.13928 25.602ZM7.33003 24.55C7.99277 24.55 8.53003 25.0873 8.53003 25.75H4.53003C4.53003 27.2964 5.78363 28.55 7.33003 28.55V24.55ZM8.53003 25.75V23.5833H4.53003V25.75H8.53003ZM8.52942 23.6329L8.53572 23.3783L4.53695 23.2792L4.53064 23.5338L8.52942 23.6329ZM8.53388 23.4279C8.5723 22.6535 8.89689 21.9186 9.44776 21.3677L6.61934 18.5393C5.36516 19.7935 4.62626 21.4665 4.53879 23.2297L8.53388 23.4279ZM9.44777 21.3677C10.0354 20.7801 10.8323 20.45 11.6634 20.45V16.45C9.77149 16.45 7.95709 17.2015 6.61933 18.5393L9.44777 21.3677ZM11.6634 20.45H20.33V16.45H11.6634V20.45Z"
                fill="black"
                mask="url(#path-2-inside-1_13_3229)"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.7865 15.7122C13.052 15.5985 10.8701 13.3457 10.8701 10.5833L10.8746 10.3663C10.9883 7.63192 13.2411 5.45 16.0034 5.45L16.2204 5.4545C18.9549 5.56821 21.1368 7.82096 21.1368 10.5833L21.1323 10.8003C21.0186 13.5347 18.7658 15.7167 16.0034 15.7167L15.7865 15.7122ZM16.1973 14.1114C18.0586 14.0108 19.5368 12.4697 19.5368 10.5833L19.5316 10.3895C19.4309 8.52822 17.8898 7.05 16.0034 7.05L15.8096 7.05523C13.9483 7.15587 12.4701 8.69697 12.4701 10.5833L12.4753 10.7772C12.576 12.6384 14.1171 14.1167 16.0034 14.1167L16.1973 14.1114Z"
                fill="black"
              />
            </svg>

            {/* <span>login</span> */}
          </a>
        </div>
      );
    }
  };


    const getLoginStringTwo = () => {
      if (loginEnabled) {
        if (loggedUserName) {
          return <div className="ThemeTwoWelcomeWrapper">
            <button className="ThemeTwoAfterLoginButton">
              <svg width="26" height="26" viewBox="0 0 26 26" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M17.33 15.45C18.6914 15.45 19.9971 15.9908 20.9598 16.9535C21.9225 17.9162 22.4633 19.2219 22.4633 20.5833V22.75L22.4571 22.8504C22.4077 23.2448 22.0712 23.55 21.6633 23.55C21.2215 23.55 20.8633 23.1918 20.8633 22.75V20.5833C20.8633 19.6463 20.4911 18.7475 19.8284 18.0849L19.6714 17.9372C19.0273 17.3672 18.195 17.05 17.33 17.05H8.66336L8.44788 17.0566C7.5894 17.109 6.77658 17.4732 6.16492 18.0849C5.50229 18.7475 5.13003 19.6463 5.13003 20.5833V22.75L5.1238 22.8504C5.07443 23.2448 4.73787 23.55 4.33003 23.55C3.8882 23.55 3.53003 23.1918 3.53003 22.75V20.5833L3.53634 20.3288C3.59928 19.06 4.13103 17.8561 5.03355 16.9535C5.99623 15.9908 7.30192 15.45 8.66336 15.45H17.33Z"
                  fill="white" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M12.7863 12.7122C10.0519 12.5985 7.87 10.3457 7.87 7.58334L7.8745 7.36635C7.98821 4.63193 10.241 2.45001 13.0033 2.45001L13.2203 2.45452C15.9547 2.56823 18.1367 4.82098 18.1367 7.58334L18.1322 7.80034C18.0185 10.5348 15.7657 12.7167 13.0033 12.7167L12.7863 12.7122ZM13.1972 11.1115C15.0584 11.0108 16.5367 9.46971 16.5367 7.58334L16.5314 7.38948C16.4308 5.52824 14.8897 4.05001 13.0033 4.05001L12.8095 4.05524C10.9482 4.15588 9.47 5.69699 9.47 7.58334L9.47522 7.77721C9.57587 9.63846 11.117 11.1167 13.0033 11.1167L13.1972 11.1115Z"
                  fill="white" />
              </svg>
              <span>{safeCharAt(loggedUserName)}</span>
            </button>
            <ul className="ThemeTwoListLog">
              <li className="ThemeTwoDesktopUserName">{loggedUserName} <span className="ThemeTwoDesktopUserEmail">{loggedUserEmail}</span></li>
              {/* <li className="ThemeTwoDesktopUserEmail">{loggedUserEmail}</li> */}
              <li> <a onClick={logoutUser} href="javascript:void(0)">Logout</a></li>
            </ul>
          </div>
        }
        return <div className="ThemeTwoLoginWrapper">
          <a href={loginLink} className="ThemeThreeLoginAnchor"><svg width="26" height="26" viewBox="0 0 26 26" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M17.33 15.45C18.6914 15.45 19.9971 15.9908 20.9598 16.9535C21.9225 17.9162 22.4633 19.2219 22.4633 20.5833V22.75L22.4571 22.8504C22.4077 23.2448 22.0712 23.55 21.6633 23.55C21.2215 23.55 20.8633 23.1918 20.8633 22.75V20.5833C20.8633 19.6463 20.4911 18.7475 19.8284 18.0849L19.6714 17.9372C19.0273 17.3672 18.195 17.05 17.33 17.05H8.66336L8.44788 17.0566C7.5894 17.109 6.77658 17.4732 6.16492 18.0849C5.50229 18.7475 5.13003 19.6463 5.13003 20.5833V22.75L5.1238 22.8504C5.07443 23.2448 4.73787 23.55 4.33003 23.55C3.8882 23.55 3.53003 23.1918 3.53003 22.75V20.5833L3.53634 20.3288C3.59928 19.06 4.13103 17.8561 5.03355 16.9535C5.99623 15.9908 7.30192 15.45 8.66336 15.45H17.33Z"
              fill="white" />
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M12.7863 12.7122C10.0519 12.5985 7.87 10.3457 7.87 7.58334L7.8745 7.36635C7.98821 4.63193 10.241 2.45001 13.0033 2.45001L13.2203 2.45452C15.9547 2.56823 18.1367 4.82098 18.1367 7.58334L18.1322 7.80034C18.0185 10.5348 15.7657 12.7167 13.0033 12.7167L12.7863 12.7122ZM13.1972 11.1115C15.0584 11.0108 16.5367 9.46971 16.5367 7.58334L16.5314 7.38948C16.4308 5.52824 14.8897 4.05001 13.0033 4.05001L12.8095 4.05524C10.9482 4.15588 9.47 5.69699 9.47 7.58334L9.47522 7.77721C9.57587 9.63846 11.117 11.1167 13.0033 11.1167L13.1972 11.1115Z"
              fill="white" />
          </svg>
            <span>login</span>
          </a>
        </div>
      }
    }

  const checkSelected = (item: any) => {
    if (!item || !item.type) return false;

    if (item.type === 1 && Array.isArray(requestIdList) && item.secid) {
      // console.log("item.secid ::: " + item.secid);
      if (requestIdList.some(request_Id => request_Id && item.secid.toString() === request_Id)) {
        return true;
      }
    }

    if (item.type === 2 && Array.isArray(requestIdList)) {
      if (requestIdList.some(request_Id => request_Id && item.tagpath === request_Id)) {
        return true;
      }
    }

    if (item.type === 3 && Array.isArray(REQUEST_URL_List) && REQUEST_HOSTNAME) {
      if (REQUEST_URL_List.some(REQUEST_URL => {
        let requestUrlWithoutSlash: any = null;
        if (!REQUEST_URL) return false;
        if (REQUEST_URL.startsWith('/')) { requestUrlWithoutSlash = REQUEST_URL.slice(1) }
        else {
          requestUrlWithoutSlash = REQUEST_URL;
          REQUEST_URL = '/' + REQUEST_URL;
        }
        const httpUrl = `http://${REQUEST_HOSTNAME}${REQUEST_URL}`;
        const httpsUrl = `https://${REQUEST_HOSTNAME}${REQUEST_URL}`;

        return item.searchQuery === REQUEST_URL || item.searchQuery === httpUrl || item.searchQuery === httpsUrl || item.searchQuery === requestUrlWithoutSlash ||
          item.path === REQUEST_URL || item.path === httpUrl || item.path === httpsUrl || item.path === requestUrlWithoutSlash;
      })) {
        return true;
      }
    }

    return false;
  };



  return (
    <div className="card_wrapper ThemeThreeOtherpageHeader themeThreeMainHeaderWrap" onClick={onClick}>
      <CacheProvider value={getMUICache()}>
        <Box sx={{ flexGrow: 1 }} className="header themeThreeHeaderWrap">
          <Grid spacing={2} container direction="column">
            <Grid item md={12}>
              {rendertopBar()}
            </Grid>
            <Grid item md={12} className='menu-wrap'>
              <div className="themeThreeMainMenuWrap">
                <div className="themeThreeMainMenu">
                  <div className="navbar ThemeThreeNavbar ">
                    <div className="ThmeThreeOtherPageLogoWrap">
                      <div className="sidebar-menu-icon mobileThemeThreeIcon" onClick={() => { toggleMainMenu(); toggleClass(); toggleMenu(); }}>
                        <IconButton size="large" edge="start" color="inherit" aria-label="open drawer" sx={{ mr: 2 }} className={isActive ? 'hamburgerActiveClass' : 'hamburgerInactiveClass'}>
                          <MenuIcon />
                        </IconButton>
                      </div>
                      <div id="HeaderlogoIn" className="">
                        <Link href="/" aria-label="logo" target={fetchAnchorValue(anchorLinksValue, "/")} className="main-logo">
                          {headerData?.mainLogo && <img src={getImageUrl(headerData?.mainLogo, "422424", 300, undefined, "", false, props.CONSTANTS)} alt="logo" width="96" height="36" />}
                        </Link>

                        <div className="ThemeTwoLoginMainWrapper theme-4">
                      {getLoginStringTwo()}
                    </div>

                      </div>

                    </div>
                    <List orientation="horizontal"
                      sx={{
                        '--List-padding': '4px',
                        '--List-gap': '0px',
                        '--ListItem-paddingX': '7px',
                        '--ListItem-paddingY': '0px',
                        padding: "0px",
                      }}
                      itemType="http://www.schema.org/SiteNavigationElement"
                      itemScope={true}
                      className = "L-oneUlWrapper"
                      style = {{backgroundColor: L1BgColor}}
                    >

                      {!(typeof window !== 'undefined' && PAGEBUILDER_URLS.some(url => window.location.origin.includes(url))) ?
                        <>
                          {menuData.map((item: any, index: any) => {
                            // Rendering Navigation
                            // console.log("Menu Data :", menuData);
                            // console.log("Menu Data Item :", item);
                            // console.log("Sections for item :", item.sections);
                            const isSelected = checkSelected(item);
                            const hasVisibleSections = item.sections?.some((section: any) => checkSelected(section));
                            return (
                              <ListItem key={`menu_${index}`} className={`menuItem ${isSelected || hasVisibleSections ? "active" : ""}`} itemProp="name" content={item.name}>
                                <div className="ParentAnchorThemeThree">
                                  <a key={'l1_' + index} href={item.path} target={fetchAnchorValue(anchorLinksValue, item.path)} style={{ fontWeight: isSelected || hasVisibleSections ? "bold" : "normal", borderBottom: isSelected || hasVisibleSections ? "2px solid black" : "none",  color: L1TextColor, backgroundColor: L1BgColor }} itemProp="url" content={getUrllocal(defaultDomainUrl, item.path)}>{item.name}</a>
                                </div>
                                <div className="submenitemsWrapper">
                                  <div className="OtherPagesubmenuItemsMainWrapper">
                                    {/* Submenu Logic */}
                                    {item.sections && Array.isArray(item.sections) && item.sections.length > 0 && (
                                      <div className={`submenitemsWrapper`} style={{backgroundColor: L2BgColor}}>
                                        <div className={`OtherPagesubmenuItems ${isSelected || hasVisibleSections ? "visible" : "hidden"}`}>
                                          {item.sections.map((section: any, sectionIndex: any) => {
                                            const isSubsectionActive = checkSelected(section)
                                            // console.log("section.secid :", section.secid);
                                            return (
                                              <div key={`submenu_${sectionIndex}`} className={`submenuItem ${isSubsectionActive ? "active" : ""}`} itemProp="name" content={section.name}>
                                                <a
                                                  key={'l2_' + sectionIndex}
                                                  href={section.path}
                                                  itemProp="url"
                                                  content={getUrllocal(defaultDomainUrl, section.path)}
                                                  style={{ fontWeight: isSubsectionActive ? "bold" : "normal", color: L2TextColor, backgroundColor: L2BgColor }}
                                                >
                                                  {section.name}
                                                </a>
                                              </div>
                                            );
                                          })}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </ListItem>
                            );
                          })}
                          {/* More Dropdown for additional items */}
                          {/* {menuData.length > MAX_MENU_ITEMS && (
                            <ListItem className="OhterHeaderMoreButtonWrapper showMore">
                              <div className="OhterHeaderMoreButton">
                                <span>More</span>
                              </div>
                              <ul className="OtherHeaderdropdownMenu">
                                {menuData.slice(MAX_MENU_ITEMS).map((item: any, index: number) => (
                                  <li key={`moreMenu_${index}`} className="submenu-item" itemProp="name" content={item.name}>
                                    <a
                                      href={item.path}
                                      itemProp="url"
                                      content={getUrllocal(defaultDomainUrl, item.path)}
                                    >
                                      {item.name}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </ListItem>
                          )} */}
                        </>
                        :
                        menuData.map((item: any, index: any) => {
                          // Pagebuilder navigation
                          return (
                            <ListItem key={'kk_' + index} itemProp="name" content={item.name}>
                              <a key={'l1_' + index} href={item.path} target={fetchAnchorValue(anchorLinksValue, item.path)} itemProp="url" content={getUrllocal(defaultDomainUrl, item.path)} style={{ color: L1TextColor, backgroundColor: L1BgColor }}>
                                {item.name}
                              </a>
                            </ListItem>
                          )
                        })}

                        {(menuItems.length > noOfHeaderItems) &&
                          renderMoreOption()
                        }

                      {showSearch && <div className='themeThreeSearchIcon'>
                        <Button className='ThemeThreeToggleButton' onClick={handleOpen}> {!Closebtn && <SearchIcon className='ThemeThreeSearchButton' onClick={() => showSearchBar()} />} {Closebtn && <SearchIcon className='ThemeThreeCloseSearchButton' onClick={() => closehandler()} />}</Button>
                        <div>
                          <Modal
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                          >
                            <Box sx={style} className="ThemeThreeModaleBox" >
                              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                                {(showSearch && SearchBar) &&
                                  <div className='themeSearchMainWrap'>
                                    <Button className="ThemeThreeModaleBoxButton" onClick={handleClose}><CloseIcon /> </Button>
                                    <div className="search-main">
                                      <div className="search">
                                        <TextField
                                          id=""
                                          placeholder='Search'
                                          className='ThemeThreeSearchWrapWidth'
                                          type='text'
                                          onKeyDown={(e) => handleKeyPress(e)}
                                          onChange={e => setSearchValue(e.target.value)}
                                          InputProps={{
                                            endAdornment: (
                                              <InputAdornment position="end">
                                                <SearchIcon onClick={() => handleSearchClick(searchValue, hostId)} />
                                              </InputAdornment>
                                            )
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                }
                              </Typography>
                            </Box>
                          </Modal>
                        </div>
                      </div>}
                    </List>
                    <div className="ThemeThreeLoginMainWrapper theme-5">
                      {getLoginString()}
                    </div>

                  </div>
                </div>
              </div>


            </Grid>
          </Grid>

          {showMainMenu &&
            <Grid item md={12} className='menu-wrap' style={{ backgroundColor: props.HamburgerBgColor }}>
              <DrawerComponentThree
                props={props}
                toggleMainMenu={toggleMainMenu}
                menuItems={toogleMenuData}
                domainUrl={defaultDomainUrl}
                HamburgerBgColor={props.HamburgerBgColor}
                HamburgerTextColor={props.HamburgerTextColor}
                hostId={hostId}
                anchorLinksValue={anchorLinksValue}
              />
            </Grid>
          }
        </Box>
      </CacheProvider>
    </div>
  );
}
